<template>
  <dd class="mt-2" :class="{'hidden':  !show}">
    <div>
      <div class="grid grid-cols-6 gap-6 mt-2">
        <div class="col-span-6 sm:col-span-3">
          <ui-form-item label="Вопрос" required>
            <ui-form-textarea :value="question.name" @update:modelValue="v=>{set('name', v)}"
                              placeholder="Пример: Сколько будет 2*2?"/>
          </ui-form-item>

          <ui-form-item class="mt-2" label="Баллы" :required="true">
            <ui-form-number :value="question.cost" @update:modelValue="v=>{set('cost', v)}"/>
          </ui-form-item>

          <ui-form-item class="mt-2" label="Тип ответа" required>
            <ui-form-select-custom :model-value="question.type" @update:modelValue="setType" :items="types"/>
          </ui-form-item>

        </div>

        <ui-form-item class="col-span-6 sm:col-span-3" label="Изображение">
          <ui-form-image img-cls="max-h-48" :url="`events/${question.event_id}/questions/${question.id}/images`" :server_image="question.image"/>
        </ui-form-item>
      </div>

      <component class="mt-5" v-if="question.type" :is="'question-' + question.type.id" :index="index"/>

      <ui-form-item class="mt-5" label="Решение (пояснение)">
        <ui-form-text :value="question.answer_comment" @update:modelValue="v=>{set('answer_comment', v)}"
                      placeholder="Пример: Квадрат + Ромб + Овал + Треугольник = КРОТ"/>
      </ui-form-item>

    </div>
  </dd>
</template>

<script>

import UiFormItem from "@/components/ui/form/UiFormItem";
import UiFormTextarea from "@/components/ui/form/UiFormTextarea";
import UiFormSelectCustom from "@/components/ui/form/select-menus/UiFormSelectCustom";

import UiFormNumber from "@/components/ui/form/UiFormNumber";
import UiFormText from "@/components/ui/form/UiFormText";
import QuestionSingleSelect from "@/views/events/edit/questions/types/QuestionSingleSelect";
import QuestionText from "@/views/events/edit/questions/types/QuestionText";
import UiFormImage from "@/components/ui/form/UiFormImage";

import _types from './types'

export default {
  name: "EventEditQuestion",
  components: {
    UiFormImage,
    QuestionText,
    QuestionSingleSelect,
    UiFormText,
    UiFormNumber, UiFormSelectCustom, UiFormTextarea, UiFormItem
  },
  props: {
    index: {type: Number, required: true, default: 0},
    show: {type: Boolean, default: false}
  },
  data() {
    return {
      types: _types,
    }
  },
  methods: {
    setType(type) {
      if (this.question.type.id === type.id)
        return
      this.set('type', type)
      this.set('props', {})
    },
    set(name, value) {
      this.$store.dispatch('event/questions/change_prop', {
        index: this.index, name, value
      })
    },

  },
  computed: {
    question() {
      return this.$store.getters["event/questions/item"](this.index)
    },
  },
}
</script>

<style scoped>

</style>